module.exports = __webpack_public_path__ + "media/images/icon_arrow_return-9e095c1e743e2009adf962eb5e1044b3.png";